<template>
  <div class="akl">
    <div class="bod-view-txt">
      <div class="os_noticeRes" v-if="isSummaryView" >
        <SurveyCompleted :edit="editable" @edit="editable = true"/>
      </div>

      <div class="os_noticeRes" v-if="!isSummaryView">
        <div class="widM padTM cont_Wrap">
          <!-- 설문 헤더 -->
          <SurveyHeader />

          <template v-if="infoAvailable">

            <!-- 설문 참가자 정보 -->
            <SurveyParticipantInfo v-if="isInitCompleted" />

            <!-- 참가 약관 -->
            <SurveyConsent v-if="existAttendant" />
          </template>

          <!-- 참가 액티비티 예약 -->
          <SurveyActivityList v-if="existAttendant && activityAvailable" />
          
          <!-- 귀국일 선택 -->
          <SurveyReturnScheduleList v-if="existAttendant && activityAvailable" />
          
          <hr style="border-top:1px solid #ddd; background:#f4f4f4;">

          <div class="widM txtC marTML" v-if="isOpenSaveButton">
            <button
              class="bt-akl-blue large pf23-submit "
              :class="{ NCAcmi_submitNope: submitBtnDisabled }"
              @click="submitSurvey"
              :disabled="submitBtnDisabled"
            >신청하기</button>
          </div>
          <div class="widM txtC marTML" v-if="isOpenCancelButton">
            <button
              class="bt-akl-blue large pf23-submit "
              :class="{ NCAcmi_submitNope: submitBtnDisabled }"
              @click="cancelSurvey"
            >신청취소</button>
          </div>
          <div class="padM disIb"></div>
        </div>
        <SurveyPopupLayer v-if="survey_popup">
          <component :is="popupComponent" />
        </SurveyPopupLayer>
        <SurveyPopupLayerActivity v-show="survey_activity_popup" />
        <SurveyPopupLayerInterestFee v-if="survey_interestFee_popup" />
      </div>
    </div>
    <SurveyLoading v-if="survey_loading" />
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SINGAPORE, FETCH_DATAS, ATTENDING_LIST, EXIST_ATTENDANT, MEMBER_ATTENDANTS, SET_ABO_UID, SET_LOADING, VALIDATE_DATA, SUBMIT_SURVEY, ACTIVITY_QUESTIONS, INFO_AVAILABLE, ACTIVITY_AVAILABLE, GET_ORIGINAL_ATTENT_YN, GET_NAME_OF_INDEX, SET_FILES_FOR_DELETE } from '@/store/actions/survey'
import { SurveyHeader, SurveyParticipantInfo, SurveyConsent, SurveyActivityList, SurveyLoading, SurveyPopupLayer, SurveyPopupLayerActivity, SurveyPopupLayerInterestFee, SurveyReturnScheduleList, SurveyCompleted } from './components'
import { getMessage } from '@/utils/survey'

export default {
  name: 'Survey',
  components: {
    SurveyHeader,
    SurveyParticipantInfo,
    SurveyConsent,
    SurveyActivityList,
    SurveyLoading,
    SurveyPopupLayer,
    SurveyPopupLayerActivity,
    SurveyPopupLayerInterestFee,
    SurveyReturnScheduleList,
    SurveyCompleted
  },
  data() {
    return {
      btnDisabled: false,
      editable: false,
      initOriginalAttentYn: false
    }
  },
  computed: {
    ...mapState(SURVEY_SINGAPORE, {
      abo_uid: state => state.abo_uid,
      survey_loading: state => state.loading,
      survey_popup: state => state.popup.open,
      popupComponent: state => state.popup.component,
      survey_activity_popup: state => state.popup_activity,
      survey_interestFee_popup: state => state.popup_interestfee,
      mode: state => state.mode,
      isInitCompleted: state => state.isInitCompleted,
      pinLevel: state => state.pin_level,
      origins: state => state.originals,
    }),
    ...mapGetters(SURVEY_SINGAPORE, {
      attendingList: ATTENDING_LIST,
      existAttendant: EXIST_ATTENDANT,
      memberAttendants: MEMBER_ATTENDANTS,
      activities: ACTIVITY_QUESTIONS,
      infoAvailable: INFO_AVAILABLE,
      activityAvailable: ACTIVITY_AVAILABLE,
      originalAttentYn: GET_ORIGINAL_ATTENT_YN,
      nameOfIndex: GET_NAME_OF_INDEX
    }),
    submitBtnDisabled() {
      // 사업자가 존재하지 않거나, btnDisabled가 true
      return this.memberAttendants.length === 0 || this.btnDisabled;
    },
    isSummaryView() {
      // 신청 정보가 없는 최초 
      if (this.mode == 'W') return false;
      
      // 신청 정보가 존재하는 경우
      if (this.mode == 'E' && this.initOriginalAttentYn && !this.editable) { 
        return true;
      } else { 
        // 신청 정보가 존재하지만 모두 불참 처리된 경우 
        return false;
      }
    },
    isOpenSaveButton() { 
      // 신청 대상이 있는 경우는 신청하기 버튼 활성화 
      return !this.isOpenCancelButton
    },
    isOpenCancelButton() { 
      // 기존 신청에서 모두 불참으로 변경한 경우만 버튼 활성화 
      return this.isInitCompleted && this.initOriginalAttentYn && !this.existAttendant
    }
  },
  methods: {
    async cancelSurvey() { 
      this.btnDisabled = true; // 중복 submit 으로 인한 중복 데이터 insert 방지
      try {
        // 개인별 자료 삭제 
        this.origins
          .filter(user => user.attendance_yn == 'Y')
          .map(user => user.questions['Q024'])
          .forEach(question => this.$store.commit(`${SURVEY_SINGAPORE}/${SET_FILES_FOR_DELETE}`, `${question.path}/${question.original_name}`));

        const isSuccess = await this.$store.dispatch(`${SURVEY_SINGAPORE}/${SUBMIT_SURVEY}`);            
        
        if(isSuccess) {
          alert(getMessage('ALERT_SUBMIT_CANCEL_SUCCESS'));
          this.$router.go(this.$router.currentRoute);
        }
      } catch (error) {
        alert(error.message);
        this.btnDisabled = false;
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_LOADING}`, false);
      }
    }, 
    async submitSurvey() {
      this.btnDisabled = true; // 중복 submit 으로 인한 중복 데이터 insert 방지
      try {
        // 입력 데이터 체크
        const userErrores = await this.$store.dispatch(`${SURVEY_SINGAPORE}/${VALIDATE_DATA}`);
        let messages = ""; // 전체 오류 메세지 
        let firstErrorId = undefined;
        let withFoArea = false;
        let isLeft = false;

        Object.keys(userErrores)
          .map(user => {
          if (userErrores[user].errorMessages.length > 0) { 
            let messageOfUser = ''; // 참여자 별 오류 메세지 

            messageOfUser += user + ' 님 필수 입력사항입니다.\n'
            userErrores[user].errorMessages.forEach(error => {

              if (!firstErrorId) {
                isLeft = this.nameOfIndex.indexOf(user) == 0;
                switch(error.cause) { 
                  case 'name': firstErrorId = 'NCAcmi_name1'; break;
                  // Acitivity 는 한곳에 있어서 sq_code + '-top' 으로 찾음 
                  case 'Q029': 
                  case 'Q030': firstErrorId = error.cause + '-' + 'top'; break; 

                  // 약관은 한곳에 있어서 consent 검색 으로 찾음 
                  case 'consent-require': 
                  case 'consent-option': firstErrorId = error.cause; break;

                  case 'Q040': withFoArea = true;

                  // 그외 다른 항목에 대해서는 신청자 정보를 찾음  sq_code + index 
                  default : firstErrorId = error.cause + '-' + this.nameOfIndex.indexOf(user); // 그외 다른 항목에 대해서는 신청자 정보를 찾음 
                }
              }

              // 오류 메세지 형태 
              let errorMessage = error.message.replace(user+'님의', '').replace(user+'님이', '').replace(user+'님은', '') + '\n'

              // 주민번호가 앞/뒤자리의 출력메세지가 동일하여 중복 제거 처리 
              messageOfUser = messageOfUser.replace(errorMessage, '') + errorMessage;
            });
            // 전체 메세지 += 사용자별 메세지 처리 
            messages += messageOfUser + '\n';
          }
        })

        if (messages) { 
          if ( isLeft && withFoArea ) { 
            try { 
              document.getElementById(`${firstErrorId}-FO`).scrollIntoView({ behavior: 'smooth' });
            }catch(e){}
          } 
          document.getElementById(firstErrorId).scrollIntoView({ behavior: 'smooth' }) 

          alert(messages);
          this.btnDisabled = false;
          return ;
        }

        // 사용자 정보 입력/수정 가능하고
        // 동반가족 포함 4명 이상일 때 컨펌 얼럿 노출
        if(this.infoAvailable && this.attendingList.length > 3) {
          if(!confirm(getMessage('CONFIRM_ATTENDANT_RULE2'))) {
            this.btnDisabled = false;
            return false;
          }
        }
        
        const isSuccess = await this.$store.dispatch(`${SURVEY_SINGAPORE}/${SUBMIT_SURVEY}`);
        if(isSuccess) {
          // alert(getMessage(this.activityAvailable ? 'ALERT_SUBMIT_ACTIVITY_SUCCESS' : 'ALERT_SUBMIT_INFO_SUCCESS'));
          alert(getMessage('ALERT_SUBMIT_SAVE_SINGAPORE_SUCCESS'));
          this.$router.go(this.$router.currentRoute);
        }
      } catch (error) {
        alert(error.message);
        this.btnDisabled = false;
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_LOADING}`, false);
      }
    },
  },
  async mounted() {
    this.$store.commit(`${SURVEY_SINGAPORE}/${SET_LOADING}`, true);
    const s_code = 'SG';
    const wave_number = this.$route.params.wave_number;
    try {
      await this.$store.dispatch(`${SURVEY_SINGAPORE}/${FETCH_DATAS}`, { s_code, wave_number, abo_uid: this.abo_uid });
    } catch (error) {
      alert(error.message);
      console.error(error.stack);
      window.location.href = process.env.AMWAY_ROOT_URL;
    }
    this.initOriginalAttentYn = this.originalAttentYn;
    this.$store.commit(`${SURVEY_SINGAPORE}/${SET_LOADING}`, false);
  },
  /**
   * 페이지 라우팅 되기 전에
   * SSO Login 체크, 서베이 코드 및 서베이 회차 validation
   * 
   */
  async beforeRouteEnter(to, from, next) {
    try {
        // SSO Login 체크
        const { data } = await axios.get(`${process.env.OCC_ROOT_URL}/sso/authorizeEvent`, { withCredentials: true });
        if(data.header.status === 'ERROR') {
          window.location.href = `${process.env.AMWAY_ROOT_URL}/login`;
        } else {
          const wave_number = to.params.wave_number;
          const abo_uid = atob(data.customerUid);
          if(Number(wave_number) === NaN || Number(wave_number) < 1) {
            alert(getMessage('ERROR_INVALID'));
            window.location.href = process.env.AMWAY_ROOT_URL;
            return next(false);
          }

          return next(vm => {
            vm.$store.commit(`${SURVEY_SINGAPORE}/${SET_ABO_UID}`, abo_uid);
          });
        }
      } catch (error) {
        console.error(`${error.message}(${error.status})`);
        alert(getMessage('ERROR_AUTHORIZE'));
        window.location.href = `${process.env.AMWAY_ROOT_URL}/login`;
        return next(false);
      }
  }
}
</script>

<style>
@import './font_kr.css';
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-new-v2.css');

body{margin:0 auto}
.bod-view-txt{padding-top:0}

.os_noticeRes .pf23-subTit{background:#2c2c2c; border-radius:5px;}
.os_noticeRes .pf23-lineBtm{border-top:1px solid #e3e3e3;}

/* 내국인 구분 영역 */
.os_noticeRes .pf23visible{display:none;}
.os_noticeRes .pf23visible.active{display:block;}

/* radio btn */
.os_noticeRes .amway-theme .pf23-radioBtn label{margin-bottom:0;}
.os_noticeRes .amway-theme .pf23-radioBtn .radio-label input.amw-global-radio:checked + .amw-radio-overlay:before{background:#33597e; width:8px; height:8px; top:4px; left:4px;}
.os_noticeRes .amway-theme .pf23-radioBtn .radio-label input.amw-global-radio:checked + .amw-radio-overlay:after{border:2px solid #33597e; width:18px; height:18px; border-radius: 50%; content: ''; display:block; top: 50%; left: 50%; transform: translate(-50%, -50%); position:absolute;}

/* input, select off */
.akl .os_noticeRes .pf23Wrap input[disabled], .akl .os_noticeRes .pf23Wrap select[disabled]{border:1px solid #ddd !important; }
.akl .os_noticeRes .pf23Wrap select[disabled]{color:#bbb;}

/* radio btn off */
.akl .os_noticeRes .pf23Wrap .amway-theme input.amw-global-radio:disabled~.amw-radio-overlay{background:#f4f4f4; border:1px solid #ddd;}
.akl .os_noticeRes .pf23Wrap .amway-theme input.amw-global-radio:disabled~.amw-label-radio-text{color:#bbb;}
.akl .os_noticeRes .pf23Wrap .amway-theme input.amw-global-radio:disabled~.amw-label-radio-text em{color:#bbb;}


@media screen and (max-width:639px) {
  .os_noticeRes .widM.pf23Wrap{width:100%;}
  .os_noticeRes .pf23-tit{max-width: 760px; width: 95%; margin-left: auto; margin-right: auto;}
}


/* 참가자 정보 공통 */
.os_noticeRes .pf23-inFo-radio{display:flex; justify-content:space-between;}
.os_noticeRes .pf23-inFo-radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative; top:-3px;}
.os_noticeRes .pf23-inFo-common input{width:55%;}
.os_noticeRes .pf23-inFo-common label{color:#56565A; margin-bottom:0;}
.os_noticeRes .pf23-inFo-select{width:55%;}
.os_noticeRes .pf23-inFo-select.pf23-country select{color:#808285; background: url(https://www.amway.co.kr/_ui/_noticeImg/2022/09/0929_NCAcmi/NCAcmi_cardArrow.jpg) right center no-repeat #ffffff; width:100%;}
.os_noticeRes .pf23-inFo-select.pf23-date select{color:#808285; background: url(https://www.amway.co.kr/_ui/_noticeImg/2022/09/0929_NCAcmi/NCAcmi_cardArrow.jpg) right center no-repeat #ffffff; width:100%;}
.os_noticeRes .pf23-inFo-select.pf23-date{display:flex; gap:0 .35em;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-safe{display:flex; align-items: center; justify-content: flex-end;}


@media screen and (max-width:639px) {
  .os_noticeRes .pf23-inFo-radio label .amw-label-radio-text{font-size:16px;}
  .os_noticeRes .pf23-inFo-wrap > .widM{width:100%;}
  .os_noticeRes .pf23-inFo-wrap .floL.widM, .os_noticeRes .pf23-inFo-wrap .floR.widM{width:95% !important;}
  .os_noticeRes .pf23-inFo-wrap .floR.widM div.pf23-padB0{padding-bottom:0;}
  .os_noticeRes .pf23-inFo-select .form-control{font-size:15px !important;}
}


/* 참가자 정보 파일박스 */
.os_noticeRes .pf23-inFo-file{display:flex; justify-content: space-between; align-items: center; color:#56565A; margin-bottom:0;}
.os_noticeRes .pf23-inFo-file span.pf23-fileBtn{background: #7d8c9b; border-radius: 5px; font-weight: 500; color: #fff; height: 40px; text-align: center; padding-top: 0.5em; width:55%; display:inline-block;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-blank01{height:71px;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-blank02{height:121px;}
/* 7.31 input 영역 높이값 추가 */
.os_noticeRes .pf23-inFo-blank03{height:97.8px;}
/* /// 7.31 input 영역 높이값 추가 */
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-w-file01{height:40px;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-w-file02{height:50px;}
.os_noticeRes .pf23-inFo-file.pf23-fileInput{justify-content: flex-end;}
.os_noticeRes .pf23-inFo-file.pf23-fileInput input{height: 40px; width: 55%; border-radius: 5px;}
.os_noticeRes .pf23-inFo-file a{position:absolute; background:none; padding-right:8px;}

@media screen and (max-width:639px) {
  .os_noticeRes .pf23-inFo-file span.pf23-fileBtn{padding-top:.7em;}
  .os_noticeRes .pf23-inFo-wrap .pf23-inFo-blank01, .os_noticeRes .pf23-inFo-wrap .pf23-inFo-blank02, .os_noticeRes .pf23-inFo-wrap .pf23-inFo-w-file01, .os_noticeRes .pf23-inFo-wrap .pf23-inFo-w-file02{display:none;}
}


/* 참가자 정보 */
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-L{display:flex; align-items: center; justify-content: space-between;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-R{display:flex; align-items: center; justify-content: flex-end;}

/* 7.31 휴대폰 번호 영역 추가 및 수정 */
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C .pf23-input-wrap{display: flex; align-items: center; justify-content: flex-start;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C .pf23-input-wrap label{margin-right: auto;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C .pf23-input-wrap input{width: 45%; margin-left: 8px;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C-R .pf23-input-wrap label{margin-right: auto;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C-R .pf23-input-wrap{display:flex; align-items: center; justify-content: flex-end;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C-R .pf23-input-wrap input{width: 45%; margin-left: 8px;}

.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C .pf23-input-wrap-normal{display: flex; align-items: center; justify-content: flex-start;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C .pf23-input-wrap-normal label{margin-right: auto;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C-R .pf23-input-wrap-normal label{margin-right: auto;}
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-C-R .pf23-input-wrap-normal{display:flex; align-items: center; justify-content: flex-end;}

/* /// 7.31 휴대폰 번호 영역 추가 및 수정 */


@media screen and (max-width:639px) {
  .os_noticeRes .pf23-inFo-wrap .pf23-inFo-R{justify-content: space-between;}
  .os_noticeRes .pf23-inFo-wrap .pf23-inFo-L .amway-theme label:nth-child(2), .os_noticeRes .pf23-inFo-wrap .pf23-inFo-R .amway-theme label:nth-child(2){margin-right:1.5em;}     
  /* 7.31 휴대폰 번호 영역 추가 및 수정 */
  .os_noticeRes .pf23-inFo-wrap .pf23-inFo-C-R .pf23-input-wrap{justify-content: space-between;}
  /* /// 7.31 휴대폰 번호 영역 추가 및 수정 */
}


/* 안전 확인 */
.os_noticeRes .pf23-inFo-wrap .pf23-inFo-safe-L{display:flex; align-items: center; justify-content: flex-end;}

@media screen and (max-width:639px) {
  .os_noticeRes .pf23-inFo-wrap .widM.pf23-inFo-safe-wrap{width:95%;}
  .os_noticeRes .pf23-inFo-wrap .pf23-inFo-safe-wrap .amway-theme label:nth-child(2){margin-right:1.5em;}     
}


/* 참가 약관 동의 */
.os_noticeRes .pf23-itemAgree{display: flex; align-items: center; justify-content: space-between;}
.os_noticeRes .pf23-itemAgree-radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative; top:-3px;}

@media screen and (max-width:639px) {
  .os_noticeRes .pf23-itemAgree .floL, .os_noticeRes .pf23-itemAgree .floR{margin:0;}
  .os_noticeRes .pf23-itemAgree-radio label .amw-label-radio-text{font-size:16px;}
}


/* 참가 약관 동의 팝업 */
.os_noticeRes .pf23-itemAgreePop .cart-popup__header{background:#fff;}
.os_noticeRes .pf23-itemAgreePop .cart-popup__item-info{border-top:1px solid #ddd;}
.os_noticeRes .pf23-itemAgreePop thead th{ color:#00305e; font-weight:500; background:#f4f4f4;}
.os_noticeRes .pf23-itemAgreePop tbody tr td{line-height:1.35;}
.os_noticeRes .pf23-itemAgreePop tbody tr td:nth-child(3), .os_noticeRes .pf23-itemAgreePop tbody tr td.pf23-itemAgreePop-key{color:#2c2c2c; font-weight:500; font-size:17px;}
.os_noticeRes .pf23-itemAgreePop tbody tr:nth-child(even){background:#f4f4f4;}

@media screen and (max-width:639px) {
  .os_noticeRes .pf23-itemAgreePop tbody tr td:nth-child(3), .os_noticeRes .pf23-itemAgreePop tbody tr td.pf23-itemAgreePop-key{font-size:16px;}
}


/* 액티비티 정보 안내 */
.os_noticeRes a.pf23-activeBtn{width:100%; border-radius:5px; padding:.75em 0; background:#20893d; color:#fff;}
.bt-akl-blue.btn_close.pf23-activePop-btn{color:#fff;}
.bt-akl-blue.btn_close.pf23-activePop-btn:hover{color:#002F5F;}


/* 액티비티 예약 */
.os_noticeRes .pf23-active-radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative; top:-3px;}
.os_noticeRes .pf23-active-radio label .amw-label-radio-text em{color:#808285;}
.os_noticeRes .pf23-active-radio label{padding-bottom:.7em;}
.os_noticeRes .pf23-active-radio input.amw-global-radio{top:0; width:18px; height:18px;}
.os_noticeRes .pf23-active-radio .radio-label + .radio-label{margin-left:0 !important; padding-bottom:.7em;}
.os_noticeRes .pf23-active-radio .radio-label + .radio-label:last-child{padding-bottom:0;}


/* 제출 */
.os_noticeRes .bt-akl-blue.large.pf23-submit{width:100%; background:#00305e; border: 1px solid #00305e; border-radius:5px;}
.os_noticeRes .bt-akl-blue.pf23-submit:hover{color:#fff;}
.os_noticeRes .bt-akl-blue.pf23-submit.pf23-submit-unable{border:1px solid #00305e; color:#00305e; background:#fff;}

@media screen and (max-width:639px) {
  .os_noticeRes .bt-akl-blue.large.pf23-submit{font-size:18px; height:55px; line-height:54px;}
}


/* 신청 완료 */
.os_noticeRes .pf23-inFo-wrap .pf23-complet-R{display:flex; align-items: center; justify-content: space-between;}
.os_noticeRes .pf23-inFo-wrap .pf23-complet-L{display:flex; align-items: center; justify-content: space-between;}
.os_noticeRes .pf23-complet-common input{width:55%; border:none;}
.os_noticeRes .pf23-complet-common label{color:#56565A; margin-bottom:0;}

/* 7.31 휴대폰 번호 추가 */
.akl input[type="text"].check-red{border: 2px solid red;}
.akl input[type="date"].check-red{border: 2px solid red;}
.akl input[type="radio"].check-red{border: 2px solid red;}
.akl select.check-red{border: 2px solid red;}
/* ///7.31 휴대폰 번호 추가 */


/* 8.17 추가 */
.os_noticeRes .osResTbRow, .os_noticeRes .osResTb05{max-width: 100%;}
.activeityScrollWrap .activeityScroll > .osResTbBlock .osResTb05 > tbody tr td{text-align: left;}
.os_noticeRes textarea{min-height: auto; resize: none; border: none; outline: none;}
.os_noticeRes .floR.no-info{height: 100vh; text-align: center; display: flex; vertical-align: middle; align-items: center;}
.infoTxt{font-size: 20px; font-weight: 500; width: 100%; max-width: 100%;}
@media screen and (max-width:639px) {
  .os_noticeRes .floR.no-info{height: auto;}
}
/* /// 8.17 추가 */
</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/Survey.vue